import { useState } from 'react'
import { authApi } from '../services/api'

interface TermsModalProps {
  onAgree: () => void
  onDecline: () => void
}

export default function TermsModal({ onAgree, onDecline }: TermsModalProps) {
  const [loading, setLoading] = useState(false)

  const handleAgree = async () => {
    setLoading(true)
    try {
      await authApi.agreeTerms()
      onAgree()
    } catch {
      // ignore
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="fixed inset-0 flex items-end sm:items-center justify-center z-50"
      style={{ backgroundColor: 'rgba(49, 49, 49, 0.5)' }}
    >
      <div
        className="card w-full max-w-sm"
        style={{
          margin: '0 24px 24px',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <h2
          style={{
            fontFamily: '"Noto Sans SC", sans-serif',
            fontSize: 18,
            fontWeight: 500,
            color: '#313131',
            letterSpacing: '0.15em',
            marginBottom: 16,
          }}
        >
          服务条款
        </h2>

        <div
          style={{
            overflowY: 'auto',
            flex: 1,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 13,
              color: '#9a9a9a',
              lineHeight: 1.8,
              letterSpacing: '0.15em',
            }}
          >
            <p style={{ marginBottom: 12 }}>
              欢迎使用浅形定制订单跟踪系统。使用本系统前，请您仔细阅读以下条款：
            </p>
            <p style={{ marginBottom: 12 }}>
              1. 本系统仅用于查询和管理浅形定制订单的加工进度、物流信息及相关服务。
            </p>
            <p style={{ marginBottom: 12 }}>
              2. 您提供的个人信息（如手机号、收货地址）将仅用于订单处理目的，我们不会将其用于其他商业用途或向第三方披露。
            </p>
            <p style={{ marginBottom: 12 }}>
              3. 订单状态信息由加工人员和发货人员实时更新，可能存在短暂延迟。
            </p>
            <p style={{ marginBottom: 12 }}>
              4. 材料寄件人通过访问口令提交的信息（快递单号、材料照片）将关联到对应订单，仅供订单相关方查看。
            </p>
            <p>
              5. 如发现订单信息有误，请及时联系客服处理。
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={onDecline}
            disabled={loading}
            className="flex-1 btn-secondary"
          >
            不同意
          </button>
          <button
            onClick={handleAgree}
            disabled={loading}
            className="flex-1 btn-primary"
          >
            {loading ? '处理中' : '同意'}
          </button>
        </div>
      </div>
    </div>
  )
}
